export { default } from './CamIcon';
